//Scripts for ko formResponse-template in /Views/Shared/_Templates.cshml
let signaturePads = [];

function clearSignPad(event) {
    let id = event.target.id.split('-')[2];
    // Clear signature strokes
    signaturePads[id].signaturePad.clear();
    // Also clear any background image that may represent a previously stored signature
    var canvasId = signaturePads[id].id;
    var canvasEl = document.getElementById(canvasId);
    if (canvasEl) {
        canvasEl.style.backgroundImage = 'none';
    }
}

function hasDeadline() {
    var hasDeadline;
    if (rootViewModel === undefined) initRootViewModel();
    if (ko.isObservableArray(rootViewModel.allResponses)) {
        rootViewModel.allResponses().forEach(function (item) {
            if (item.Deadline() != null) hasDeadline = true;
            else {
                if (hasDeadline == undefined || hasDeadline == false)
                    hasDeadline = false;
            }
        });
    }
    return hasDeadline;
}

function validateDeadline(deadline) {
    passValidation = false;
    if (
        deadline == null ||
        deadline == '' ||
        deadline == undefined ||
        moment(deadline).isValid() == false
    ) {
        passValidation = false;
        toastr.error('Fristen må være en gyldig dato.');
    } else if (moment(deadline).isBefore(moment())) {
        passValidation = false;
        toastr.error('Fristen kan ikke være i fortiden.');
    } else {
        passValidation = true;
    }
    return passValidation;
}

function hasResponsibleManager() {
    var hasResponsibleManager;
    if (rootViewModel === undefined) initRootViewModel();
    if (ko.isObservableArray(rootViewModel.allResponses)) {
        rootViewModel.allResponses().forEach(function (item) {
            if (item.ClientFormResponseResponsibleManagers().length > 0) {
                hasResponsibleManager = true;
            } else {
                if (
                    hasResponsibleManager == undefined ||
                    hasResponsibleManager == false
                )
                    hasResponsibleManager = false;
            }
        });
    }
    return hasResponsibleManager;
}

function setFormResponseDeadline(id, deadline) {
    if (!validateDeadline(deadline)) {
        return;
    }
    var id = id;
    dataToSend = { deadline: deadline };
    $.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        url: '/api/ClientForm/UpdateClientFormResponseDeadline/' + id,
        data: JSON.stringify(deadline),
        complete: function (xhr) {
            if (xhr.status === 200) {
                toastr.success('Fristen ble endret.');
                updateDeadlineFormResponseList(id, deadline);
                updateDeadlineFormResponse(deadline);
            } else toastr.error('En feil har oppstått.');
        },
    });
}
function updateDeadlineFormResponse(deadline) {
    if (rootViewModel == undefined) initRootViewModel();
    if (ko.isObservable(rootViewModel.formResponse().Data().Deadline)) {
        rootViewModel.formResponse().Data().Deadline(deadline);
    } else {
        rootViewModel.formResponse().Data().Deadline = ko.observable(deadline);
    }
}

function updateStatusFormResponse(status) {
    if (rootViewModel == undefined) initRootViewModel();
    if (ko.isObservable(rootViewModel.formResponse().Data().Status)) {
        rootViewModel.formResponse().Data().Status(status);
    } else {
        rootViewModel.formResponse().Data().Status = ko.observable(status);
    }
}

function updateDeadlineFormResponseList(id, deadline) {
    if (rootViewModel == undefined) initRootViewModel();
    if (ko.isObservableArray(rootViewModel.allResponses)) {
        let response = ko.utils.arrayFirst(
            rootViewModel.allResponses(),
            function (item) {
                return item.Id() === id;
            }
        );
        if (ko.isObservable(response.Deadline)) response.Deadline(deadline);
        else response.Deadline = ko.observable(deadline);
    }
}

function updateResponsibleManagersToFormResponseList(id, responsibleManagers) {
    if (rootViewModel == undefined) initRootViewModel();
    if (ko.isObservableArray(rootViewModel.allResponses)) {
        let response = ko.utils.arrayFirst(
            rootViewModel.allResponses(),
            function (item) {
                return item.Id() === id;
            }
        );
        if (
            ko.isObservableArray(response.ClientFormResponseResponsibleManagers)
        )
            response.ClientFormResponseResponsibleManagers(responsibleManagers);
        else
            response.ClientFormResponseResponsibleManagers =
                ko.observableArray(responsibleManagers);
    }
}

function addClientFormResponseResponsibleManager(selectedUser, object) {
    $.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        url: '/api/ClientForm/AddClientFormResponseResponsibleManager/',
        data: ko.mapping.toJSON(selectedUser),
        dataType: 'json',
        success: function (data) {
            var newSelectedUser = ko.mapping.fromJS(data);
            updateResponsibleManagerListsAdd(
                newSelectedUser,
                selectedUser,
                object
            ),
                toastr.success('Ansvarlig ble lagt til.');
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}
function removeClientFormResponseResponsibleManager(object, selectedUser) {
    $.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        url: '/api/ClientForm/DeleteClientFormResponseResponsibleManager/',
        data: ko.mapping.toJSON(selectedUser),
        complete: function (xhr) {
            if (xhr.status === 200)
                updateResponsibleManagerListsRemove(selectedUser, object);
            else toastr.error('En feil har oppstått.');
        },
    });
}

// Fjerner skjemaansvarlig fra skjemaet og legger tilbake i listen over potensielle ansvarlige
function updateResponsibleManagerListsRemove(selectedUser, object) {
    let responsibleManagers = object
        .Data()
        .ClientFormResponseResponsibleManagers()
        .filter((item) => item !== selectedUser);
    object.Data().ClientFormResponseResponsibleManagers(responsibleManagers);
    let potentialResponsibleManager = object.PotentialResponsibleManagers();
    potentialResponsibleManager.push(selectedUser);
    object.PotentialResponsibleManagers(potentialResponsibleManager);
    updateResponsibleManagersToFormResponseList(
        object.Data().Id(),
        responsibleManagers
    );
}

// Legger til skjemaansvarlig i skjemaet og fjerner fra listen over potensielle ansvarlige
function updateResponsibleManagerListsAdd(
    newSelectedUser,
    selectedUser,
    object
) {
    let potentialResponsibleManager = object
        .PotentialResponsibleManagers()
        .filter((item) => item !== selectedUser);
    object.PotentialResponsibleManagers(potentialResponsibleManager);
    let responsibleManagers = object
        .Data()
        .ClientFormResponseResponsibleManagers();
    responsibleManagers.push(newSelectedUser);
    object.Data().ClientFormResponseResponsibleManagers(responsibleManagers);
    updateResponsibleManagersToFormResponseList(
        object.Data().Id(),
        responsibleManagers
    );
}

function createFormResponse(
    id,
    object,
    checkExisting,
    mandatory,
    xtraInfo,
    absenceId,
    fromDate,
    toDate,
    isFillingOut
) {
    initRootViewModel();
    if (checkExisting == undefined) checkExisting = false;

    if (mandatory == undefined)
        //if mandatory = true, then hide close and save-buttons
        mandatory = false;

    if (xtraInfo == undefined)
        //if xtraInfo, then show this in form (eg name of vehicle)
        xtraInfo = '';
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url:
            '/api/ClientForm/CreateResponseDetails/' + id + '/' + checkExisting,
        success: function (data) {
            if (toDate != undefined) {
                let contextToDate = ko.utils.arrayFirst(
                    data.Columns,
                    function (i) {
                        return i.Context == 'todate';
                    }
                );

                if (contextToDate != null) contextToDate.Value = toDate;
            }

            if (fromDate != undefined) {
                let contextFromDate = ko.utils.arrayFirst(
                    data.Columns,
                    function (i) {
                        return i.Context == 'fromdate';
                    }
                );

                if (contextFromDate != null) contextFromDate.Value = fromDate;
            }

            data.IsFillingOut = isFillingOut;

            let random = randomIntFromInterval(1, 100);
            object(
                ko.mapping.fromJS({
                    ReadOnly: false,
                    Data: ko.observable(ko.mapping.fromJS(data)),
                    Attachments: null,
                    ManagerAttachments: null,
                    Comments: null,
                    Comment: null,
                    ManagerComments: null,
                    AllowComments: ko.observable(false),
                    Random: random,
                    Users: null,
                    PotentialResponsibleManagers: null,
                    Mandatory: mandatory,
                    XtraInfo: xtraInfo,
                    AbsenceId: absenceId,
                    FormLogs: null,
                    SelectedStatusFormViewId: null,
                    SettableStatuses: null,
                    SelectedManager: null,
                    SelectedDeadline: null,
                    IsSaveEnabled: ko.observable(true),
                })
            );
            let signPads = document.getElementsByClassName('signature-pad');
            let cancelButtons = document.getElementsByClassName('sign-clear');
            signaturePads = [];
            if (signPads.length > 0) {
                for (let index = 0; index < signPads.length; index++) {
                    let element = signPads[index];
                    let signaturePad = new SignaturePad(element, {
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        penColor: 'rgb(0, 0, 0)',
                    });
                    signaturePads.push({ id: element.id, signaturePad });
                    cancelButtons[index].setAttribute(
                        'id',
                        'clear-index-' + index
                    );
                }
            }
        },
        error: function (data) {
            alert('ERROR: ' + data.Message);
        },
    });
}

let absenceChecks = {};

function absenceCheckStart(typeId) {
    typeId = String(typeId);
    if (!absenceChecks.hasOwnProperty(typeId)) absenceChecks[typeId] = 0;
    absenceChecks[typeId]++;
}

function absenceCheckCompleted(typeId) {
    typeId = String(typeId);
    if (!absenceChecks.hasOwnProperty(typeId)) {
        absenceChecks[typeId] = 0;
        return;
    }
    if (absenceChecks[typeId] < 1) return;
    absenceChecks[typeId]--;
}
function checkFormAbsence(element) {
    if (element === undefined) return;

    //Get form element
    if ($(element).closest('div.formContainer').length === 0) return;

    let formElement = $(element).closest('div.formContainer');
    //get absence type id
    if (!formElement.find('input[name="absencetypeid"]')) return;

    //Get all form datepickers
    let dateFields = formElement.find('input.date_field');
    if (dateFields.length < 1) return;

    let fromDate = '';
    let toDate = '';
    dateFields.each(function () {
        // Check if field has date value
        let textDate = $(this).val();
        if (textDate === undefined || textDate === null || textDate === '')
            return;

        let date = moment(textDate, 'DD.MM.YYYY');
        if (textDate.includes('/')) date = moment(textDate, 'MM/DD/YYYY');
        if (date === undefined || date === null) return;

        if (fromDate === '') {
            //Set as fromDate
            fromDate = date;
            return;
        }

        //Less than fromDate => fromDate/  toDate === "" => toDate = fromDate
        if (date.isBefore(fromDate)) {
            if (toDate === '') toDate = fromDate;
            fromDate = date;
            return;
        }

        //toDate === "" =>  toDate = date
        if (toDate === '' && date.isAfter(fromDate)) {
            toDate = date;
            return;
        }

        //toDate < date => toDate = date;
        if (moment(toDate).isBefore(date)) toDate = date;
    });

    if (!fromDate)
        //no dates set
        return;

    let url = '/api/ClientForm/CheckAbsence';
    let typeId = formElement.find('input[name="absencetypeid"]').val();
    url += '?absenceTypeId=' + typeId;
    url += '&fromDate=' + fromDate.toJSON();
    if (toDate) url += '&toDate=' + toDate.toJSON();

    formElement.find('.errorMessage').remove();

    absenceCheckStart(typeId);
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: url,
        success: function (data) {
            absenceCheckCompleted(typeId);
            if (
                data === undefined ||
                data === null ||
                !Array.isArray(data) ||
                data.length < 1
            )
                return;

            let errorMessage = '';
            for (const element of data) {
                if (errorMessage !== '') errorMessage += '\n<br />';
                if (element.ToDate !== null)
                    errorMessage +=
                        'Det er allerede registert fravær fra ' +
                        formatDate(element.FromDate, false, false) +
                        ' til ' +
                        formatDate(element.ToDate, false, false);
                else
                    errorMessage +=
                        'Det er allerede registert fravær den ' +
                        formatDate(element.FromDate, false, false);
            }

            //Get the last date element, parent div and errormessage after
            formElement
                .find('input.form-control.hasDatepicker')
                .last()
                .closest('div')
                .after(
                    '<div class="col-sm-12"><div class="alert alert-danger small-text tw-mt-4">' +
                    errorMessage +
                    '</div></div>'
                );
        },
        error: function () {
            absenceCheckCompleted(typeId);
            toastr.error('En feil har oppstått under kontroll av fravær.');
        },
    });
}

function getFormResponseColumns(clientformresponse) {
    return $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetResponseDetails/' + clientformresponse.Id(),
        success: function (data) {
            if (data != null) {
                clientformresponse.Columns = ko.observableArray([]);
                for (const element of data.Columns) {
                    clientformresponse.Columns.push(ko.mapping.fromJS(element));
                }
            }
        },
        error: function () {
            toastr.error('Klarte ikke å hente skjemadetaljer.');
        },
    });
}

function getFormResponse(
    id,
    object,
    gta,
    mandatory,
    xtraInfo,
    ignoreAttachments,
    ignoreComments,
    isFillingOut
) {
    initRootViewModel();
    if (mandatory == undefined)
        //if mandatory = true, then hide close and save-buttons
        mandatory = false;

    if (xtraInfo == undefined)
        //if xtraInfo, then show this in form (eg name of vehicle)
        xtraInfo = '';

    if (ignoreAttachments == undefined) ignoreAttachments = false;

    if (ignoreComments == undefined) ignoreComments = false;

    $.blockUI();
    return $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetResponseDetails/' + id,
        success: function (data) {
            if (data != null) {
                let allowComments = data.FormReadOnlyMode; // Til versjon 1.3 er rettighetene endret. Får kun se skjemaet dersom admin, nærmeste leder, mitt eget eller tildelt tilgang. Ergo alltid lov til å kommentere hvis readonly //IsAllowComments(data.ActiveUserId, data.EmployeeId, data.ManagerId, data.FormReadOnlyMode);
                data.IsFillingOut = isFillingOut;
                let random = randomIntFromInterval(1, 100);
                object(
                    ko.mapping.fromJS({
                        ReadOnly: ko.observable(data.FormReadOnlyMode),
                        Data: ko.observable(ko.mapping.fromJS(data)),
                        Attachments: ko.observableArray(),
                        ManagerAttachments: ko.observableArray(),
                        Comments: ko.observableArray(),
                        ManagerComments: ko.observableArray(),
                        Comment: createFormComment(id),
                        AllowComments: ko.observable(allowComments),
                        Random: random,
                        Id: id,
                        Users: null,
                        PotentialResponsibleManagers: ko.observableArray([]),
                        Mandatory: mandatory,
                        XtraInfo: xtraInfo,
                        FormLogs: ko.observableArray([]),
                        SelectedStatusFormViewId: ko.observable(),
                        SettableStatuses: ko.observableArray([]),
                        SelectedManager: ko.observable(),
                        SelectedDeadline: ko.observable(null),
                        IsSaveEnabled: ko.observable(true),
                    })
                );

                if (!ignoreAttachments) {
                    getFormAttachments(id, object().Attachments);
                    getFormManagerAttachments(id, object().ManagerAttachments);
                }

                if (!ignoreComments) {
                    getFormComments(id, object().Comments);
                    getFormManagerComments(id, object().ManagerComments);
                }

                if (gta) gotoAttachment(object);

                getSettableStatuses(object().SettableStatuses);

                // Initialize signature pads for existing responses and display stored signatures when editing
                try {
                    // Defer to allow KO to render the template DOM
                    setTimeout(function () {
                        let signPads = document.getElementsByClassName('signature-pad');
                        let cancelButtons = document.getElementsByClassName('sign-clear');
                        signaturePads = [];
                        if (signPads.length > 0) {
                            for (let index = 0; index < signPads.length; index++) {
                                let element = signPads[index];
                                let signaturePad = new SignaturePad(element, {
                                    backgroundColor: 'rgba(255, 255, 255, 0)',
                                    penColor: 'rgb(0, 0, 0)',
                                });
                                signaturePads.push({ id: element.id, signaturePad });
                                if (cancelButtons[index]) {
                                    cancelButtons[index].setAttribute('id', 'clear-index-' + index);
                                }
                            }
                        }

                        // For each signature field with an existing attachment, set the image as the canvas background
                        try {
                            if (object && typeof object === 'function' && object() && object().Data && object().Data() && object().Data().Columns) {
                                let cols = object().Data().Columns();
                                for (let i = 0; i < cols.length; i++) {
                                    let col = cols[i];
                                    if (col.FieldType && col.FieldType() === 'Sign' && col.AttachmentId && col.AttachmentId() > 0) {
                                        let canvas = document.getElementById(col.FieldId());
                                        if (canvas) {
                                            canvas.style.backgroundImage = 'url(/api/Document/Attachment/' + col.AttachmentId() + ')';
                                            canvas.style.backgroundRepeat = 'no-repeat';
                                            canvas.style.backgroundPosition = 'center';
                                            canvas.style.backgroundSize = 'contain';
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            if (window.console && console.warn) console.warn('Failed setting signature canvas backgrounds', e);
                        }
                    }, 0);
                } catch (e) {
                    if (window.console && console.warn) console.warn('Failed initializing signature pads', e);
                }
            }
            $.unblockUI();
        },
        error: function () {
            $.unblockUI();
            toastr.error('En feil har oppstått.');
        },
    });
}
function getPotentialResponsibleManagers(object, clientFormResponseId) {
    let id = clientFormResponseId;
    if (object().length < 1) {
        $.ajax({
            type: 'GET',
            dataType: 'json',
            url: '/api/ClientForm/GetPotentialResponsibleManagers/' + id,
            success: function (data) {
                for (let i = 0; i < data.length; i++) {
                    object.push(ko.mapping.fromJS(data[i]));
                }
            },
            error: function () {
                toastr.error('En feil har oppstått.');
            },
        });
    }
}

function getFormAttachments(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetAttachments/' + id,
        success: function (data) {
            for (const element of data) {
                object.push(ko.mapping.fromJS(element));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}
function getFormManagerAttachments(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetManagerAttachments/' + id,
        success: function (data) {
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}

function getSettableStatuses(object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetSettableStatuses',
        success: function (data) {
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}

function getSettableStatuses(object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetSettableStatuses',
        success: function (data) {
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}
function getFormComments(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetComments/' + id,
        success: function (data) {
            for (const element of data) {
                object.push(ko.mapping.fromJS(element));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}
function getFormManagerComments(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetManagerComments/' + id,
        success: function (data) {
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}
function getFormLogs(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/FormLog/' + id,
        success: function (data) {
            object.removeAll();
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            object = ko.observableArray([]);
            toastr.error('En feil har oppstått.');
        },
    });
}

function getFormManagerComments(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/GetManagerComments/' + id,
        success: function (data) {
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            toastr.error('En feil har oppstått.');
        },
    });
}

function getFormLogs(id, object) {
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/api/ClientForm/FormLog/' + id,
        success: function (data) {
            object.removeAll();
            for (let i = 0; i < data.length; i++) {
                object.push(ko.mapping.fromJS(data[i]));
            }
        },
        error: function () {
            object = ko.observableArray([]);
            toastr.error('En feil har oppstått.');
        },
    });
}

//Workaround for inconsistent naming of the root viewModel.
// Did not dare to change the naming of the view models as it might break who knows what?
// Maybe not needed any more as most of the issues have been given a more robust workaround,
// and this is only used for setting the status of a form response.
// Status setting is hard to solve without using using somehting like this as it needs to access
// the list of responses to set the status on the list and to remove the response from the list when
// the response is finalized.
// Have not fully checked if the allResponses object has consistent naming. And the statuses object
// is only found in List and ListByCategory endpoints.
let rootViewModel;
function initRootViewModel() {
    if (typeof viewModel !== 'undefined') {
        rootViewModel = viewModel;
    } else if (typeof viewmodel !== 'undefined') {
        rootViewModel = viewmodel;
    } else if (typeof viewModelQM !== 'undefined') {
        rootViewModel = viewModelQM;
    } else if (typeof adminViewModel !== 'undefined') {
        rootViewModel = adminViewModel;
    } else if (typeof dmViewModel !== 'undefined') {
        rootViewModel = dmViewModel;
    } else if (typeof masterViewModel !== 'undefined') {
        rootViewModel = masterViewModel;
    } else if (typeof workOrderAssignmentViewModel !== 'undefined') {
        rootViewModel = workOrderAssignmentViewModel;
    } else if (typeof workOrderLineViewModel !== 'undefined') {
        rootViewModel = workOrderLineViewModel;
    } else if (typeof workOrderAssignmentItemViewModel !== 'undefined') {
        rootViewModel = workOrderAssignmentItemViewModel;
    } else if (typeof overviewViewModel !== 'undefined') {
        rootViewModel = overviewViewModel;
    } else if (typeof employeeReportsViewModel !== 'undefined') {
        rootViewModel = employeeReportsViewModel;
    } else if (typeof deviationReportsViewModel !== 'undefined') {
        rootViewModel = deviationReportsViewModel;
    } else if (typeof vehicleReportsViewModel !== 'undefined') {
        rootViewModel = vehicleReportsViewModel;
    } else if (typeof fileUploadReportsViewModel !== 'undefined') {
        rootViewModel = fileUploadReportsViewModel;
    } else if (typeof fileStatusReportsViewModel !== 'undefined') {
        rootViewModel = fileStatusReportsViewModel;
    } else if (typeof activityEventsReportsViewModel !== 'undefined') {
        rootViewModel = activityEventsReportsViewModel;
    } else if (typeof exeptionsReportsViewModel !== 'undefined') {
        rootViewModel = exeptionsReportsViewModel;
    } else if (typeof energyEntriesViewModel !== 'undefined') {
        rootViewModel = energyEntriesViewModel;
    } else if (typeof avgUsageViewModel !== 'undefined') {
        rootViewModel = avgUsageViewModel;
    } //Probably safe to assume typos in this list, but as far as I know only the first 3 are used.
}

function setFormResponseStatus(responseId, statusId) {
    var id = responseId;
    let ids = [id, statusId];
    return Q.when(
        $.ajax({
            contentType: 'application/json',
            type: 'POST',
            url: '/api/ClientForm/SetStatus/',
            data: JSON.stringify(ids),
            success: function () {
                // TODO if(!ko.isObservable(rootViewModel.statuses)) { rootViewModel.statuses = ko.observableArray(getFormStatuses()); }
                // TODO make getFormStatuses() function and api call

                if (
                    ko.isObservableArray(rootViewModel.allResponses) &&
                    ko.isObservableArray(rootViewModel.statuses)
                ) {
                    var responseToBeUpdated = ko.utils.arrayFirst(
                        rootViewModel.allResponses(),
                        function (r) {
                            return r.Id() === responseId;
                        }
                    );
                    var status = ko.utils.arrayFirst(
                        rootViewModel.statuses(),
                        function (s) {
                            return s.Id() === statusId;
                        }
                    );
                    responseToBeUpdated.StatusId(statusId);
                    responseToBeUpdated.Status(status.Name());
                    if (status.Id() === 3) {
                        rootViewModel.allResponses.remove(responseToBeUpdated);
                        toastr.success(
                            'Skjemaet er ferdigbehandlet. Du finner det igjen under Arkiv'
                        );
                    } else if (status.Id() === 7) {
                        rootViewModel.allResponses.remove(responseToBeUpdated);
                        toastr.success(
                            'Skjemaet er avvist. Du finner det igjen under Arkiv'
                        );
                    } else toastr.success('Status ble endret');
                } else toastr.success('Status ble endret');
                updateStatusFormResponse(status.Name());

                return Q.resolve();
            },
            error: function (data) {
                toastr.error('Det oppstod en feil');
                return Q.resolve();
            },
        })
    );
}

function removeFormAttachment(att, object) {
    if (confirm('Er du sikker?')) {
        object.Attachments.remove(att);
        DeleteEntity(
            'ClientForm',
            'DeleteClientFormResponseAttachment',
            att.Id()
        );
    }
}
function removeFormManagerAttachment(att, object) {
    if (confirm('Er du sikker?')) {
        object.ManagerAttachments.remove(att);
        DeleteEntity(
            'ClientForm',
            'DeleteClientFormResponseManagerAttachment',
            att.Id()
        );
    }
}

function removeFormComment(comment, object) {
    if (confirm('Er du sikker?')) {
        object.Comments.remove(comment);
        DeleteEntity('ClientForm', 'DeleteClientFormComment', comment.Id());
    }
}

function removeFormManagerComment(comment, object) {
    if (confirm('Er du sikker?')) {
        object.ManagerComments.remove(comment);
        DeleteEntity(
            'ClientForm',
            'DeleteClientFormManagerComment',
            comment.Id()
        );
    }
}

function addFormComment(com, object, sms) {
    //save to database
    $.ajax({
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
        dataType: 'json',
        url:
            '/api/ClientForm/SaveClientFormResponseComment?sms=' +
            (sms != undefined ? sms : false),
        data: ko.toJSON(ko.utils.unwrapObservable(com)),
        success: function (data) {
            object.Comments.push(ko.mapping.fromJS(data));
            $('#responseCommentBox').val('');
        },
        error: function (data) {
            toastr.error('Error: ' + data.Message);
        },
    });
}
function addFormManagerComment(comment, object) {
    $.ajax({
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
        dataType: 'json',
        url: '/api/ClientForm/SaveClientFormResponseManagerComment',
        data: ko.toJSON(ko.utils.unwrapObservable(comment)),
        success: function (data) {
            object.ManagerComments.push(ko.mapping.fromJS(data));
            $('#responseManagerCommentBox').val('');
        },
        error: function (data) {
            toastr.error('Error: ' + data.Message);
        },
    });
}

function createFormComment(clientFormResponseId) {
    return ko.observable({
        Id: 0,
        Comment: '',
        ClientFormResponseId: clientFormResponseId,
    });
}

function IsFormValueChecked(data, selectedValues) {
    if (selectedValues != null) {
        let savedData = selectedValues.split('|');
        let exists = ko.utils.arrayFirst(savedData, function (item) {
            return item === data;
        });
        return exists;
    } else {
        return null;
    }
}

function IsFormValueCheckedCheck(data, selectedValues) {
    if (selectedValues != null) {
        let savedData = selectedValues.split('|');
        let exists = ko.utils.arrayFirst(savedData, function (item) {
            return item === data;
        });
        if (exists != null) return 'checked';
        else return null;
    } else {
        return null;
    }
}

function OnFormValueClick(data, parent) {
    if (parent.Value() != null) {
        let savedData = parent.Value().split('|');
        let exists = ko.utils.arrayFirst(savedData, function (item) {
            return item === data;
        });
        if (exists != null) {
            if (parent.FieldType() != 'Radio') {
                parent.Value = ko.observable(
                    parent.Value().replace(data + '|', '')
                );
                parent.Value = ko.observable(
                    parent.Value().replace('|' + data, '')
                );
                parent.Value = ko.observable(parent.Value().replace(data, ''));
            }
        } else {
            if (parent.FieldType() == 'Radio') {
                parent.Value = ko.observable(data);
            } else if (parent.FieldType() == 'Checkbox') {
                parent.Value = ko.observable(parent.Value() + '|' + data);
            }
        }
    } else {
        parent.Value = ko.observable(data);
    }
    return true;
}

function FormFieldOKAVClear(field, index) {
    //Ok - tøm og skjul inputbox
    let elId = 'ia' + field.FieldId() + '_' + index;
    let inputEl = $('#' + elId);
    $(inputEl).removeAttr('required'); //Fjern obligatorisk
    $("label[for='" + elId + "']").hide(); //Fjern evt feilmelding
    $(inputEl).hide();
    field.Value('Ok'); //Setter value til OK

    return true;
}

function FormFieldOKAVShow(field, index) {
    //Avvik - vis inputbox
    let inputEl = $('#ia' + field.FieldId() + '_' + index);
    $(inputEl).show();
    field.Value('');
    $(inputEl).attr('required', ''); //Sett obligatorisk
    return true;
}

function saveFormResponse(ctx, confirm, gta) {
    let root = ctx.$data;
    if (root.Data == undefined) root = ctx.$parent;

    let enableTimeout;
    if (ko.isObservable(root.IsSaveEnabled)) {
        root.IsSaveEnabled(false);
        enableTimeout = setTimeout(function () {
            if (ko.isObservable(root.IsSaveEnabled)) {
                root.IsSaveEnabled(true);
            }
        }, 5000);
    }

    let isNew = false;
    if (root.Data().Id() == 0) {
        isNew = true;
    }

    let absenceid = ko.utils.unwrapObservable(root.AbsenceId);
    if (absenceid != undefined && absenceid > 0) {
        //Absence
    }

    let form = $('#form' + root.Data().ClientFormId() + '_' + root.Random());

    form.validate({
        errorElement: 'div',
    });
     
    if (form.valid()) {
        return Q.when(
            saveSignAttachments(signaturePads, root.Data().Columns())
        ).then(function () {
            return new Promise((resolve, reject) => { 
                $.ajax({ 
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    url: '/api/ClientForm/SaveResponseDetails',
                    data: ko.toJSON(ko.utils.unwrapObservable(root.Data())),
                    success: function (data) {
                        if (ko.isObservable(root.IsSaveEnabled)) {
                            root.IsSaveEnabled(true);
                        }
                        if (isNew) {
                            if (absenceid != undefined && absenceid > 0) {
                                ctx.$root.addFormToAbsence(absenceid, data.Id);
                            }

                            root.Data().Id(data.Id);

                            if (confirm) {
                                confirmFormResponse(ctx);
                            } else {
                                getFormResponseColumns(root.Data());
                                ctx.$root.getResponse(data.Id, gta);
                            }
                        } else if (gta) {
                            getFormResponseColumns(root.Data());
                            gotoAttachment(ctx);
                        }

                        toastr.success('Skjemaet ble lagret.');
                        resolve(data.Id); // Return the form response ID
                    },
                    error: function (data) {
                        if (ko.isObservable(root.IsSaveEnabled)) {
                            root.IsSaveEnabled(true);
                        }
                        toastr.error('En feil har oppstått. ' + data.Message);
                        reject(data);
                    },
                });
            });
        });
    } else {
        $.unblockUI();
        toastr.error('Skjemaet har mangler. Vennligst se over og prøv igjen.');
        return Promise.reject('Form validation failed');
    }
}



function saveSignAttachments(signaturePads, columns) {
    if (signaturePads != undefined) {
        let signPads = ko.utils.arrayFilter(signaturePads, function (x) {
            return !x.signaturePad.isEmpty();
        });
        let promises = [];

        ko.utils.arrayForEach(signPads, function (x, index) {
            // Compose any previously saved signature image with current strokes so both are saved together
            let promise = new Promise(function (resolve, reject) {
                try {
                    // Find related column by FieldId
                    let relatedCol = null;
                    ko.utils.arrayForEach(columns, function (i) {
                        if (x.id == i.FieldId()) {
                            relatedCol = i;
                        }
                    });

                    // Prepare offscreen canvas
                    let element = document.getElementById(x.id);
                    let tempCanvas = document.createElement('canvas');
                    if (!element) {
                        // Fallback: no canvas found, just use the signaturePad data
                        let dataURL = x.signaturePad.toDataURL();
                        let parts = dataURL.split(',');
                        let contentType = parts[0].split(':')[1];
                        let raw = window.atob(parts[1]);
                        let rawLength = raw.length;
                        let uInt8Array = new Uint8Array(rawLength);
                        for (let i = 0; i < rawLength; ++i) { uInt8Array[i] = raw.charCodeAt(i); }
                        let blob = new Blob([uInt8Array], { type: contentType });
                        let file = new File([blob], 'signature.png');
                        let formData = new FormData();
                        formData.append('files', file);
                        $.ajax({
                            signPad: x,
                            dataType: 'json',
                            url: '/api/Document/SaveAttachment',
                            data: formData,
                            processData: false,
                            contentType: false,
                            type: 'POST',
                            success: function (data) {
                                ko.utils.arrayForEach(columns, function (i) {
                                    if (x.id == i.FieldId()) { i.AttachmentId(data[0].Id); }
                                });
                                resolve();
                            },
                            error: function (err) { reject(err); }
                        });
                        return;
                    }

                    tempCanvas.width = element.width;
                    tempCanvas.height = element.height;
                    let tctx = tempCanvas.getContext('2d');

                    function uploadFromTempCanvas() {
                        try {
                            let dataURL = tempCanvas.toDataURL('image/png');
                            let parts = dataURL.split(',');
                            let contentType = parts[0].split(':')[1];
                            let raw = window.atob(parts[1]);
                            let rawLength = raw.length;
                            let uInt8Array = new Uint8Array(rawLength);
                            for (let i = 0; i < rawLength; ++i) { uInt8Array[i] = raw.charCodeAt(i); }
                            let blob = new Blob([uInt8Array], { type: contentType });
                            let file = new File([blob], 'signature.png');
                            let formData = new FormData();
                            formData.append('files', file);

                            $.ajax({
                                signPad: x,
                                dataType: 'json',
                                url: '/api/Document/SaveAttachment',
                                data: formData,
                                processData: false,
                                contentType: false,
                                type: 'POST',
                                success: function (data) {
                                    ko.utils.arrayForEach(columns, function (i) {
                                        if (x.id == i.FieldId()) { i.AttachmentId(data[0].Id); }
                                    });
                                    resolve();
                                },
                                error: function (err) { reject(err); }
                            });
                        } catch (e) {
                            reject(e);
                        }
                    }

                    // Draw previous signature image first if present, then overlay current strokes
                    if (relatedCol && relatedCol.AttachmentId && relatedCol.AttachmentId() > 0) {
                        let img = new Image();
                        img.onload = function () {
                            try { tctx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height); } catch (e) { }
                            try { tctx.drawImage(element, 0, 0, tempCanvas.width, tempCanvas.height); } catch (e) { }
                            uploadFromTempCanvas();
                        };
                        img.onerror = function () {
                            try { tctx.drawImage(element, 0, 0, tempCanvas.width, tempCanvas.height); } catch (e) { }
                            uploadFromTempCanvas();
                        };
                        img.src = '/api/Document/Attachment/' + relatedCol.AttachmentId();
                    } else {
                        try { tctx.drawImage(element, 0, 0, tempCanvas.width, tempCanvas.height); } catch (e) { }
                        uploadFromTempCanvas();
                    }
                } catch (err) {
                    reject(err);
                }
            });

            promises.push(promise);
        });
        return Q.all(promises).then(function (data) {
            return Q.resolve();
        });
    } else {
        return Q.promised();
    }
}

async function confirmFormResponse(ctx) {
    let formResponseId = await saveFormResponse(ctx, false, false);
    
    if (!formResponseId) {
        toastr.error('Kunne ikke hente skjemaets ID.');
        return;
    }

    let root = ctx.$data;
    if (root.Data == undefined) root = ctx.$parent;

    let valid = true;
    ko.utils.arrayForEach(root.Data().Columns(), function (x) {
        if (x.IsMandatory() && !x.Value() && !(x.AttachmentId() > 0)) {
            toastr.error(x.FieldName() + ' er obligatorisk');
            valid = false;
        }
    });
    if (!valid) return;

    $.blockUI();

    let isAbsence = false;
    let absenceid = ko.utils.unwrapObservable(root.AbsenceId);
    if (absenceid != undefined && absenceid > 0) {
        isAbsence = true;
    }

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url:
            '/api/ClientForm/ConfirmClientFormResponse/' +
            formResponseId +
            '?IsAbsence=' +
            isAbsence,
        success: function (data) {
            ctx.$root.getResponse(formResponseId);

            if (ctx.$root.refreshFormResponse != undefined) {
                ctx.$root.refreshFormResponse(formResponseId);
            }

            if (data != null && data.length > 0) toastr.success(data);
        },
        error: function (data) {
            toastr.error('En feil har oppstått. ' + data.Message);
        },
    });
}


function gotoAttachment(ctx) {
    if (ctx.$root != undefined) {
        cfTab(
            'A',
            ctx.$root.formResponse().Data().ClientFormId(),
            ctx.$root.formResponse().Random()
        );
        InitUpload(
            ctx.$root.formResponse(),
            ctx.$root.Localization != null ? ctx.$root.Localization() : null
        );

        $('body').animate(
            {
                scrollTop: $(
                    '[id*=tabs-A' +
                    ctx.$root.formResponse().Data().ClientFormId() +
                    ']'
                ).offset().top,
            },
            100
        );
    } else {
        cfTab('A', ctx().Data().ClientFormId(), ctx().Random());
        InitUpload(
            ctx(),
            ctx().Localization != null ? ctx().Localization() : []
        );

        $('body').animate(
            {
                scrollTop: $(
                    '[id*=tabs-A' + ctx().Data().ClientFormId() + ']'
                ).offset().top,
            },
            100
        );
    }
}

function closeFormResponse(ctx) {
    ctx.$root.formResponse(null);
    if (ctx.$root.refreshFormResponse != undefined)
        ctx.$root.refreshFormResponse();
}

function setResponseValueOk(e) {
    if (confirm('Er du sikker på at du vil gi sette dette avviket som OK?')) {
        //save to database
        $.ajax({
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            url: '/api/ClientForm/SaveResponseValueStatus/' + e.Id() + '/13',
            success: function (data) {
                e.StatusColor(data.Result.StatusColor);
                e.StatusId(data.Result.StatusId);
            },
            error: function (data) {
                alert('Error :' + data.Message);
            },
        });
    }
}
function InitUpload(object, localizationArray) {
    let o;
    if (ko.isObservable(object)) {
        o = object();
    } else {
        o = object;
    }

    let el = $("[id*='files" + o.Random() + "']");

    if (!$(el).data('kendoUpload')) {
        $(el).kendoUpload({
            async: {
                saveUrl: '/api/Document/SaveAttachments/',
                removeUrl: 'removeMe',
                autoUpload: false,
            },
            select: function () {
                if (object != undefined) {
                    if (o.Data().Id() == 0) {
                        alert(
                            'Skjemaet er ikke lagret. Du må lagre før du kan laste opp vedlegg.'
                        );
                        return false;
                    } else {
                        return true;
                    }
                } else return false;
            },
            upload: function (e) {
                e.data = { ClientFormResponseId: o.Data().Id() };
            },
            success: function (e) {
                addAttachments(e.response, o);
            },
            complete: function () {
                $('.k-widget.k-upload').find('ul').remove();
            },
            multiple: true,
            localization: {
                select:
                    localizationArray != null
                        ? getFromLocalization(
                            localizationArray,
                            'lblDragAndDrop',
                            'Legg til vedlegg her'
                        )
                        : 'Legg til vedlegg her',
                uploadSelectedFiles:
                    localizationArray != null
                        ? getFromLocalization(
                            localizationArray,
                            'lblUpload',
                            'Last opp valgte vedlegg'
                        )
                        : 'Last opp valgte vedlegg',
            },
            remove: function () { },
        });
    }
}

function InitUploadManagerAttachment(object) {
    let o;
    if (ko.isObservable(object)) {
        o = object();
    } else {
        o = object;
    }
    let id = o.Data().Id();
    element = $("[id*='manager" + o.Random() + "']");
    apiUrl = '/api/ClientForm/SaveClientFormManagerAttachments/' + id;
    if (!$(element).data('kendoUpload')) {
        $(element).kendoUpload({
            async: {
                saveUrl: apiUrl,
                removeUrl: 'removeMe',
                autoUpload: false,
            },
            select: function () {
                if (object != undefined) {
                    if (o.Data().Id() == 0) {
                        alert(
                            'Skjemaet er ikke lagret. Du må lagre før du kan laste opp vedlegg.'
                        );
                        return false;
                    } else {
                        return true;
                    }
                } else return false;
            },
            success: function (e) {
                addManagerAttachments(e.response, o);
            },
            complete: function () {
                $('.k-widget.k-upload').find('ul').remove();
            },
            localization: {
                select: 'Legg til vedlegg her',
                uploadSelectedFiles: 'Last opp valgte vedlegg',
                clearSelectedFiles: 'Fjern',
                dropFilesHere: 'Slipp filer her',
                headerStatusUploaded: '',
                headerStatusUploading: '',
                headerStatusPaused: '',
            },
            multiple: true,
        });
    }
}

function addAttachments(data, object) {
    let r = data;

    if (r != null) {
        if (ko.isObservable(object))
            object().Attachments.push(ko.mapping.fromJS(r));
        else {
            if (!object.Attachments()) {
                object.Attachments = ko.observableArray();
            }
            object.Attachments.push(ko.mapping.fromJS(r));
        }
    }
    if (r == null) {
        alert('Kunne ikke laste opp vedlegg. Lagre skjemaet først.');
    }
}

function addManagerAttachments(data, object) {
    let r = data; // ko.mapping.fromJSON(data);

    if (r != null) {
        if (ko.isObservable(object))
            object().ManagerAttachments.push(ko.mapping.fromJS(r));
        else object.ManagerAttachments.push(ko.mapping.fromJS(r));
    }
    if (r == null) {
        alert('Noe gikk galt');
    }
}

function addManagerAttachments(data, object) {
    let r = data; // ko.mapping.fromJSON(data);

    if (r != null) {
        if (ko.isObservable(object))
            object().ManagerAttachments.push(ko.mapping.fromJS(r));
        else object.ManagerAttachments.push(ko.mapping.fromJS(r));
    }
    if (r == null) {
        alert('Noe gikk galt');
    }
}

function handleFileSelect(evt, object) {
    let files = evt.target.files; // FileList object, files[0] is your file

    let data = new FormData();
    $.each(files, function (key, value) {
        data.append(key, value);
    });

    data.append('ClientFormResponseId', object.Data().Id());

    $.ajax({
        url: '/api/Document/SaveAttachments/',
        type: 'POST',
        async: true,
        data: data,
        cache: false,
        dataType: 'json',
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (d, textStatus, jqXHR) {
            addAttachments(d.response, object);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // Handle errors here
            // STOP LOADING SPINNER
        },
    });
}

function addClientFormResponseUser(o) {
    let res = [];
    $.ajax({
        url: '/api/user/GetUsersNotInClientFormResponse',
        data: { clientFormResponseId: o.Data().Id() },
        async: false,
        dataType: 'json',
        success: function (json) {
            res = json;
        },
    });

    o.Users(res);

    $('#addUsrDlg_' + o.Random()).dialog({
        width: 600,
    });
}

function addClientFormResponseUsers(o) {
    let res = [];
    $.ajax({
        url: '/api/user/GetUsersNotInClientFormResponse',
        data: { clientFormResponseId: o.Data().Id() },
        async: false,
        dataType: 'json',
        success: function (json) {
            res = json;
        },
    });
    o.Users(res);
}

function addClientFormResponseUsers(o) {
    let res = [];
    $.ajax({
        url: '/api/user/GetUsersNotInClientFormResponse',
        data: { clientFormResponseId: o.Data().Id() },
        async: false,
        dataType: 'json',
        success: function (json) {
            res = json;
        },
    });
    o.Users(res);
}

function saveClientFormResponseUser(o) {
    let userId = $('#ddUsrToAdd_' + o.Random()).val();

    if (
        confirm(
            'Er du sikker på at du vil gi denne brukeren tilgang til å se og kommentere skjemaet?'
        )
    ) {
        //save to database
        $.ajax({
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            url:
                '/api/ClientForm/AddClientFormResponseUser?userId=' +
                userId +
                '&clientFormResponseId=' +
                o.Data().Id(),
            success: function (data) {
                if (data == null) toastr.error('En feil har oppstått ');

                o.Data().ClientFormResponseUsers.push(
                    ko.mapping.fromJS(data.Result)
                );

                $('#ddUsrToAdd_' + o.Random() + ' option:selected').remove();
                $('#addUsrDlg_' + o.Random()).dialog('close');
            },
            error: function (data) {
                alert('Error :' + data.Message);
            },
        });
    }
}
function saveClientFormResponseUsers(o) {
    let userId = $('#ddUsrToAdd_' + o.Random()).val();

    if (
        confirm(
            'Er du sikker på at du vil gi denne brukeren tilgang til å se og kommentere skjemaet?'
        )
    ) {
        //save to database
        $.ajax({
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            url:
                '/api/ClientForm/AddClientFormResponseUser?userId=' +
                userId +
                '&clientFormResponseId=' +
                o.Data().Id(),
            success: function (data) {
                if (data == null) toastr.error('En feil har oppstått ');

                o.Data().ClientFormResponseUsers.push(
                    ko.mapping.fromJS(data.Result)
                );

                $('#ddUsrToAdd_' + o.Random() + ' option:selected').remove();
            },
            error: function (data) {
                alert('Error :' + data.Message);
            },
        });
    }
}

function removeClientFormResponseUser(o, y, i) {
    if (
        confirm(
            'Er du sikker på at du fjerne brukerens rettigheter til å se dette skjemaet?'
        )
    ) {
        //save to database

        $.ajax({
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            url: '/api/ClientForm/RemoveClientFormResponseUser?id=' + o.Id(),
            success: function () {
                i.Data().ClientFormResponseUsers.remove(o);
            },
            error: function (data) {
                alert('Error :' + data.Message);
            },
        });
    }
}

$(document).ready(function () {
    $('.FieldDescriptionTooltip').tooltip();
});

function cfTab(l, cfId, rand) {
    $('[id*=tabs-A' + cfId + ']').removeClass('active');
    $('[id*=tabs-F' + cfId + ']').removeClass('active');
    $('[id*=tabs-C' + cfId + ']').removeClass('active');
    $('[id*=tabs-D' + cfId + ']').removeClass('active');
    $('[id*=tabs-G' + cfId + ']').removeClass('active');
    $('[id*=tabs-H' + cfId + ']').removeClass('active');
    $('[id*=tabs-I' + cfId + ']').removeClass('active');
    $('[id*=tabs-J' + cfId + ']').removeClass('active');
    $('[id*=tabs-K' + cfId + ']').removeClass('active');

    $('[id*=T_tabs-A' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-F' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-C' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-D' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-G' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-H' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-I' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-J' + cfId + ']').removeClass('active');
    $('[id*=T_tabs-K' + cfId + ']').removeClass('active');

    $('[id*=tabs-' + l + cfId + '_' + rand + ']').addClass('active');
    $('[id*=T_tabs-' + l + cfId + '_' + rand + ']').addClass('active');
}
